// extracted by mini-css-extract-plugin
export default {"PACaseContainer":"sArboAj6","PACase":"vp0cg0Ln","LoadingContainer":"ZfGILZnx","LoadingText":"IzDX8Bf4","LoadingSpinner":"ICZefgOT"};